export default "<ng-container *ngTemplateOutlet=\"this.template\"></ng-container>\n";